import axios from 'axios';
import { getAuth } from 'firebase/auth'; // Firebase Auth import


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const TARIFF_API_BASE_URL = `${API_BASE_URL}/public/tariffs`;

class TariffService {

    async getToken() {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            return await user.getIdToken(); // Firebase'den token alıyoruz
        }
        return null;
    } 

    
    async getTariffs() {

        return axios.get(TARIFF_API_BASE_URL, {
        });
    }

    async getTariffById(tariffId) {
        const token = await this.getToken();

        return axios.get(`${TARIFF_API_BASE_URL}/${tariffId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getMainMeterRequiredIndexTypesByTariffId(tariffId) {
        const token = await this.getToken();
        return axios.get(`${TARIFF_API_BASE_URL}/${tariffId}/required-index-types-for-main-meter`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    async getMeterReadingIndexTypesByTariffId(tariffId) {
        const token = await this.getToken();
        return axios.get(`${TARIFF_API_BASE_URL}/${tariffId}/index-types-for-meter-reading`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }

        async getInvoiceIndexTypesByTariffId(tariffId) {
        return axios.get(`${TARIFF_API_BASE_URL}/${tariffId}/index-types-for-invoice`, {
        });
    }

 }

export default new TariffService();
